import $ from 'jquery';
import { onChangeFormatSizeConversionHandler } from '~loader/loader-event-handlers';

const onChangeSelectFormat = (e) => {
  var data = e.params.data;
  const { width, height } = data;

  Object.assign(window.editorLoader.newFormatRelation, data);

  $('#new-editor-format-width').val(width);
  $('#new-editor-format-height').val(height);

  onChangeFormatSizeConversionHandler();
};

export const loadSelectFormats = (formats, orientation, projectId) => {
  const selectedFormats = window.editorLoader.formats[projectId];
  const selectedFormatsItems = selectedFormats.formats.items;

  const data = formats.map((format) => {
    return {
      custom: false,
      formatobjectid: format.objectId,
      id: format.objectId,
      text: format.name + ' ' + orientation,
      unit: format.unit,
      width: format.width,
      height: format.height,
      disabled: selectedFormatsItems.some(
        (formatSelected) =>
          formatSelected.editor_project_formats_default_pointer?.objectId ===
            format.objectId || formatSelected.objectId === format.objectId
      ),
    };
  });
  $('#formats-select').select2({
    data: data,
    tags: false,
    allowClear: false,
    width: '100%',
    theme: 'bootstrap4',
    placeholder: {
      text: 'Seleziona un formato',
    },
  });

  $('#formats-select').select2('val', '0');
  $('body').off('select2:select', '#formats-select');
  $('body').on('select2:select', '#formats-select', onChangeSelectFormat);
};
